import { Helmet } from '@dr.pogodin/react-helmet';

import storeScriptsConfig from './store-scripts.json';

type StoreScriptsProps = {
  storeId?: number | string;
};

type ScriptConfig = {
  content: string;
  dateImported: string;
  type: string;
};

export const StoreScripts = ({ storeId }: StoreScriptsProps) => {
  const typedStoreScriptsConfig: Record<string, ScriptConfig[]> =
    storeScriptsConfig;
  const storeScripts = typedStoreScriptsConfig[String(storeId)];

  if (!storeScripts) return null;

  const srcScripts = storeScripts
    .filter(({ type }) => type === 'src')
    .map(({ content }) => ({
      async: true,
      type: 'text/javascript',
      src: content,
    }));

  const contentScripts = storeScripts
    .filter(({ type }) => type !== 'src')
    .map(({ content }) => ({
      type: 'text/javascript',
      innerHTML: content,
    }));

  return <Helmet script={[...srcScripts, ...contentScripts]} />;
};
